<template>
  <div class="dataBox">
    <el-table
      :data="signContractTipData"
      style="width: 100%;margin-bottom:10px;"
      border
      header-cell-class-name="cellCustomer headerCellCustomer ft14"
      cell-class-name="cellCustomer ft12"
    >
      <template slot="empty">
          <img class="data-pic" src="../../../../../assets/images/H5/null.png" alt="" />
          <br/>
          暂无数据
      </template>
      <el-table-column prop="code" label="合同编号"></el-table-column>
      <el-table-column prop="name" label="合同名称"></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column label="操作" width="257px">
        <template slot-scope="scope">
          <div class="handlerBoxCenter">
            <div class="cursorPointer goSign" @click="toSignTrue(scope.row,'1')">
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">重新发起</span>
            </div>
            <div class="cursorPointer delete" @click="deleteSign(scope.row)">
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">删除</span>
            </div>
            <!-- <div class="cursorPointer detail" @click="toDetail(scope.row)">
              <span class="icon"></span>
              <span class="iconDscp">详情</span>
            </div>-->
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
export default {
  data() {
    return {
      signContractTipData: []
    };
  },
  mounted() {},
  methods: {
    setData(data) {
      this.signContractTipData = data;
    },
    toSignTrue(row, flag) {
      if(row.type==2){//发起赋强合同
        // this.$router.push(`/personal/sign/signLoanContract?id=${row.id}`);
        this.$router.push(`/initiation/single?id=${row.id}`);
      }else{
        //发起普通合同
        this.$router.push(`/personal/sign/index?id=${row.id}&type=1&from=draft`);
      }
      
    },
    toDetail(row) {
      this.$emit("toDetail", row);
    },
    deleteSign(row) {
      this.$emit("deleteSign", row);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
